import { COMPOUNDS } from '../compounds';

export const AMIDE_COUPLING_CONDITION_GROUPS = [
  // AC_1_SET
  {
    coupling_reagent: COMPOUNDS.ETHYLPHOSPHONIC_CYCLIC_ANHYDRIDE,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_2_SET
  {
    coupling_reagent: COMPOUNDS.EDC,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_3_SET
  {
    coupling_reagent: COMPOUNDS.COMU,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_4_SET
  {
    coupling_reagent: COMPOUNDS.TFFH,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_5_SET
  {
    coupling_reagent: COMPOUNDS.TSTU,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_6_SET
  {
    coupling_reagent: COMPOUNDS.HATU,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_7_SET
  {
    coupling_reagent: COMPOUNDS.DMTMM_BF4,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_8_SET
  {
    coupling_reagent: COMPOUNDS.PYBOP,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
  // AC_9_SET
  {
    coupling_reagent: COMPOUNDS.CDI,
    base: COMPOUNDS.HUNIGS_BASE,
    solvent: COMPOUNDS.DMF_DMSO,
  },
];
